<!--

	Registers a store for a selected item or null

-->
<template>
	<div>
		<slot :selected="selected" />
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch, toNative } from "vue-facing-decorator";

import { createSelectedItemStore, useSelectedItemStore } from "./SelectedItemStore";

@Component
export class SelectedItemStoreRegistration<T> extends Vue {
	// The store name, i.e., the namespace of this selection.
	@Prop({ required: true, type: String }) protected store!: string;
	// The initially selected item. Note that this prop is not reactive, i.e., updates to it are ignored.
	@Prop({ required: false, default: null }) protected selectedItem!: T | null;

	@Watch("store")
	protected storeNameChanged(store: string, old: string): void {
		// See ListStoreRegistration for an explanation why this is not supported.
		throw Error(`Store name changed from ${old} to ${store}. You cannot change the name of a registered store. Make sure that the store name is bound to the lifetime of the parent.`);
	}

	protected created(): void {
		const store = createSelectedItemStore(this.store);
		store.set(this.selectedItem);
	}

	get selected(): T | null {
		return useSelectedItemStore(this.store).selected;
	}
}

export default toNative(SelectedItemStoreRegistration);
</script>
